import React from 'react';
import './Tours.css';

const Tours = () => {
  const tours = [
    {
      id: 1,
      name: 'Tour a Juayúa',
      icon: '🏞️',
      description: 'Descubre el encantador pueblo de Juayúa, famoso por su gastronomía y belleza natural. Recorre sus calles empedradas y disfruta de la Ruta de las Flores.',
      highlights: [
        'Recorrido por la Ruta de las Flores',
        'Gastronomía local',
        'Paisajes increíbles',
        'Pueblos coloniales'
      ],
      duration: 'Día completo'
    },
    {
      id: 2,
      name: 'Tour de Café',
      icon: '☕',
      description: 'Vive la experiencia completa del café salvadoreño desde la semilla hasta la taza. Visita fincas cafeteras y aprende sobre el proceso de producción.',
      highlights: [
        'Visita a fincas cafeteras',
        'Proceso de producción',
        'Degustación de café',
        'Historia del café salvadoreño'
      ],
      duration: 'Medio día'
    },
    {
      id: 3,
      name: 'Tour de las Cascadas',
      icon: '💦',
      description: 'Explora las hermosas cascadas de la región de Santa Ana. Una aventura refrescante en medio de la naturaleza salvadoreña.',
      highlights: [
        'Múltiples cascadas naturales',
        'Senderismo en naturaleza',
        'Posibilidad de nadar',
        'Fotografía panorámica'
      ],
      duration: 'Día completo'
    }
  ];

  return (
    <section id="tours" className="tours">
      <div className="container">
        <div className="tours-header">
          <h2 className="section-title">Nuestros Tours</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Descubre las maravillas de El Salvador con nuestros tours exclusivos
          </p>
        </div>

        <div className="tours-intro">
          <p>
            En KAWILA organizamos tours especiales para que puedas conocer lo mejor de Santa Ana
            y sus alrededores. Cada tour incluye transporte en nuestro servicio de Uber exclusivo
            para huéspedes, guías conocedores de la región y una experiencia inolvidable.
          </p>
        </div>

        <div className="tours-grid">
          {tours.map((tour) => (
            <div key={tour.id} className="tour-card">
              <div className="tour-header-card">
                <div className="tour-icon-large">{tour.icon}</div>
                <h3>{tour.name}</h3>
                <span className="tour-duration">{tour.duration}</span>
              </div>
              <p className="tour-description">{tour.description}</p>
              <div className="tour-highlights">
                <h4>Lo que incluye:</h4>
                <ul>
                  {tour.highlights.map((highlight, index) => (
                    <li key={index}>
                      <span className="check-icon">✓</span> {highlight}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="tours-special">
          <div className="special-box">
            <h3>🌋 Tour al Volcán de Santa Ana</h3>
            <p>
              ¡No te pierdas la oportunidad de visitar el imponente Volcán de Santa Ana!
              Ofrecemos servicio de transporte para llevarte a esta majestuosa maravilla natural.
            </p>
            <div className="volcano-features">
              <div className="volcano-item">
                <span>🚗</span>
                <p>Transporte incluido</p>
              </div>
              <div className="volcano-item">
                <span>⛰️</span>
                <p>Cráter espectacular</p>
              </div>
              <div className="volcano-item">
                <span>📸</span>
                <p>Vistas panorámicas</p>
              </div>
            </div>
          </div>
        </div>

        <div className="tours-info">
          <div className="info-card">
            <h4>Información Importante</h4>
            <ul>
              <li>🎒 Todos los tours incluyen transporte desde y hacia el hostal</li>
              <li>👥 Tours disponibles para grupos e individuales</li>
              <li>📅 Reserva con anticipación para garantizar disponibilidad</li>
              <li>💰 Precios especiales para huéspedes de KAWILA</li>
              <li>🗣️ Guías locales con amplio conocimiento de la región</li>
            </ul>
          </div>
        </div>

        <div className="tours-cta">
          <h3>¿Listo para la aventura?</h3>
          <p>Pregunta en recepción por nuestros tours y planifica tu próxima aventura en El Salvador</p>
        </div>
      </div>
    </section>
  );
};

export default Tours;
